import { GridWrapper } from "@insite/mobius/GridContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

export interface CustomModalStyle {
    modalStyle?: ModalPresentationProps;
}

export const customModalStyle: CustomModalStyle = {
    modalStyle: {
        closeButtonProps: {
            css: css`
                padding: 0;
                position: relative;
                margin-top: -30px;
                margin-right: -20px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            margin-right: -5px;               
                        `,
                        css`
                            margin-right: -5px; 
                        `,
                        css`
                            margin-right: -25px;
                        `,
                        css`
                            margin-right: -5px;
                            margin-top: -40px;
                        `,
                        css`
                            margin-right: -5px;
                            margin-top: -40px;
                        `,
                    ]);
                }}
                &:hover {
                    background: transparent;
                    border-color: transparent;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    width: 35px;
                    height: 35px;
                    > svg {
                        width: 35px;
                        height: 35px;
                        stroke-width: 1px;
                    }
                }
            `,
        },
        cssOverrides: {
            modalContainer: css`
                > div[class^="ContentBody"] {
                    //min-height: 148px;
                    //max-width: 526px;
                    //overflow: hidden;
                    //height: auto;
                    padding-bottom: 50px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(theme, [
                            css`
                                padding-bottom: 21px;                
                            `,
                            css`
                                padding-bottom: 21px;  
                            `,
                            css`
                                padding-bottom: 50px;  
                            `,
                            null,
                            null,
                        ]);
                    }}
                }
            `,
            /* modalBody: css`
                border-radius: 6px;
            `,

            modalContent: css`
                padding: 0px 30px;
            `, */
            modalBody: css`
                //padding: 32px 28px;
                border-radius: 7px;
                overflow: hidden;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            max-width: calc(100% - 20px);
                            padding-bottom: 20px;
                            top: 5%;
                            height: auto;
                            position: absolute;                
                        `,
                        css`
                            top: 5%;
                            max-width: calc(100% - 20px);
                            border-radius: 6px;
                            padding-bottom: 20px;
                            height: auto;
                            position: absolute;
                        `,
                        css`
                            max-width: 562px;
                            top: 10%;
                            height: auto;
                            position: absolute;
                        `,
                        css`
                            max-width: 525px;
                            top: 10%;
                            height: auto;
                            position: absolute;
                        `,
                        css`
                            max-width: 525px;
                            top: 10%;
                            margin: 0 auto;
                            height: auto;
                            position: absolute;
                        `,
                    ]);
                }}
                ${GridWrapper} {
                    max-width: 100%;
                }
            `,
 
            modalContent: css`
                padding: 0px 30px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 8px;               
                        `,
                        css`
                            padding: 0px 8px;
                        `,
                        css`
                            padding: 0px 36px 0px 28px;
                        `,
                        css`
                            padding: 0px 21px 0px 42px;
                        `,
                        css`
                            padding: 0px 21px 0px 42px;
                        `,
                    ]);
                }}
            `,

            /* modalTitle: css`
                border-bottom: unset;
                padding: 20px 30px 8px;
                > ${TypographyStyle} {
                    font-size: 28px !important; // no size in style guide
                    font-weight: bold !important;
                    text-align: left;
                }
            `, */
            modalTitle: css`
                border-bottom: unset;
                padding: 37px 21px 12px 42px;
                > ${TypographyStyle} {
                    font-size: 34px;
                    font-weight: 900;
                    text-align: left;
                    ${({ theme }) => {
                        return breakpointMediaQueries(theme, [
                            css`
                                font-size: 24px;              
                            `,
                            css`
                                font-size: 24px;
                            `,
                            css`
                                font-size: 34px;
                            `,
                            css`
                                font-size: 34px;
                            `,
                            css`
                                font-size: 34px;
                            `,
                        ]);
                    }}
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            padding: 26px 10px 12px;               
                        `,
                        css`
                            padding: 26px 10px 12px;
                        `,
                        css`
                            padding: 28px 36px 15px 28px;
                        `,
                        css`
                            padding: 37px 21px 12px 42px;
                        `,
                        css`
                            padding: 37px 21px 12px 42px;
                        `,
                    ]);
                }}
            `,
        },
    },
};

interface ADIMinimumQtyModalProps {
    isOpen: boolean;
    handleClose: Function;
    headline: string;
    subheading?: string;
    children: JSX.Element;
    errorStyle: boolean;
}

const styles = customModalStyle;

const ADIMinimumQtyModal = ({
    isOpen,
    handleClose,
    headline,
    subheading,
    children,
    errorStyle,
}: ADIMinimumQtyModalProps) => {
    return (
        <Modal
            headline={headline}
            sizeVariant="large"
            isOpen={isOpen}
            handleClose={() => handleClose()}
            {...styles.modalStyle}
        >
            {subheading && (
                <Typography
                    as="p"
                    css={css`
                        margin-bottom: 10px;
                        font-size: ${getProp("theme.typography.headerSecondary.size")};
                        color: ${errorStyle ? getColor("danger") : ""};
                    `}
                >
                    {subheading}
                </Typography>
            )}

            {children}
        </Modal>
    );
};

export default ADIMinimumQtyModal;
